<template>
  <div>
    <!-- 替换 up-popup 为通用弹窗容器，适配 web 环境 -->
    <div class="coverShow" v-show="viseable">
      <div class="container-gj" @click="handleCloseClick">
        <div class="container-gd" @click.stop>
          <!-- 知情同意书 -->
          <div v-if="demonstrateType === '知情同意书'" class="bg-other">
            <div class="header-view" style="position: relative">
              <span
                style="
                  font-size: 18px;
                  font-weight: 600;
                  color: #2b2f36;
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                "
                >知情同意书使用演示</span
              >
              <img
                src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
                @click="handleClick(1)"
                style="
                  width: 13px;
                  height: 13px;
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  right: 3px;
                  cursor: pointer;
                "
              />
            </div>
            <div class="content-box">
              <div class="title">知情同意书</div>
              <div class="desc">亲爱的参与者：</div>
              <div class="textarea-box">
                {{ consentContent }}
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 10px;
              "
            >
              <div class="signature-desc">请在下方矩形框内绘制签名</div>
              <div class="clear-text">清空</div>
            </div>
            <div class="signature-box">某某某</div>
            <div class="btn-box">
              <button class="cancel-btn">不同意并退出</button>
              <button class="save-btn">同意并继续</button>
            </div>
            <div
              class="choose-btn"
              style="margin-top: 10px; margin-bottom: 10px"
              @click="handleClick(1)"
            >
              我知道了
            </div>
          </div>

          <!-- 分享图演示 -->
          <div v-else-if="demonstrateType === '分享图演示'" class="bg-other">
            <div class="header-view" style="position: relative">
              <span
                style="
                  font-size: 18px;
                  font-weight: 600;
                  color: #2b2f36;
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                "
                >分享图演示弹窗</span
              >
              <img
                src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
                @click="handleClick(1)"
                style="
                  width: 13px;
                  height: 13px;
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  right: 3px;
                  cursor: pointer;
                "
              />
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
              "
            >
              <img
                src="https://ossfastmake.mustke.com/qrCode/tupian/1761728672253.svg"
                style="width: 40px; height: 40px"
              />
              <div class="share-view">
                <div
                  style="
                    width: 100%;
                    display: flex;
                    align-items: center;
                    margin-top: 5px;
                  "
                >
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1761728753668.svg"
                    style="width: 20px; height: 20px"
                  />
                  <div
                    style="
                      font-size: 12px;
                      font-weight: 600;
                      color: #7e7e7e;
                      margin-left: 5px;
                    "
                  >
                    {{ dataInfo.name }} | 优智问卷助手
                  </div>
                </div>
                <div
                  style="
                    font-size: 17px;
                    font-weight: 600;
                    color: #19191b;
                    margin-top: 5px;
                  "
                >
                  【{{ dataInfo.name }}】免费第三方微信问卷制作平台
                </div>
                <div style="position: relative; margin-top: 5px">
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1761728782783.svg"
                    style="width: 248.5px; height: 200px"
                  />
                  <div
                    style="
                      position: absolute;
                      top: 60px;
                      left: 50%;
                      transform: translateX(-50%);
                      font-size: 19px;
                      font-weight: 600;
                      color: #ffffff;
                      width: 200px;
                      text-align: center;
                    "
                  >
                    {{ dataInfo.title }}
                  </div>
                  <div
                    style="
                      position: absolute;
                      bottom: 40px;
                      left: 50%;
                      transform: translateX(-50%);
                      font-size: 15px;
                      font-weight: 600;
                      color: #066bff;
                      width: 90px;
                      height: 33px;
                      line-height: 33px;
                      text-align: center;
                      border-radius: 3px;
                      background-color: #ffffff;
                    "
                  >
                    {{ dataInfo.btn }}
                  </div>
                </div>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    align-items: center;
                    margin-top: 5px;
                  "
                >
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1761728843585.svg"
                    style="width: 10px; height: 10px"
                  />
                  <div
                    style="font-size: 10px; font-weight: 600; color: #7e7e7e"
                  >
                    小程序
                  </div>
                </div>
              </div>
            </div>
            <div
              class="choose-btn"
              style="margin-top: 10px; margin-bottom: 10px"
              @click="handleClick(1)"
            >
              我知道了
            </div>
          </div>

          <!-- 使用整张图片的演示 -->
          <div v-else class="bg-view">
            <div class="header-view" v-if="!special">
              <span
                style="
                  font-size: 18px;
                  font-weight: 600;
                  color: #2b2f36;
                  line-height: 24px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                "
                >{{ title }}</span
              >
              <slot name="imageBtn" :stop="true"></slot>
            </div>
            <div class="body-view" style="overflow-y: auto">
              <slot name="selectionList">
                <img :src="imgUrl" style="width: 100%; height: auto" />
              </slot>
            </div>
            <div
              class="btn-views"
              :class="{ active: special }"
              style="display: flex"
              :style="{
                justifyContent: btnNum === 1 ? 'center' : 'space-between',
              }"
            >
              <div v-if="btnNum === 2" class="btn1" @click="handleClick(1)">
                {{ cancel }}
              </div>
              <div class="btn2" @click="handleClick(2)">
                {{ confirm }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DemoPopup",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    slotStatus: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "使用演示",
    },
    btnNum: {
      type: Number,
      default: 1,
    },
    imgUrl: {
      type: String,
      default: "https://ossfastmake.mustke.com/qrCode/tupian/1752819403769.png",
    },
    cancel: {
      type: String,
      default: "不再提示",
    },
    confirm: {
      type: String,
      default: "我知道了",
    },
    demonstrateType: {
      type: String,
      default: "",
    },
    dataInfo: {
      type: Object,
      default() {
        return {
          name: "",
          title: "",
          btn: "",
        };
      },
    },
    // 新增特殊跳转展示用
    special: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viseable: false,
      // 把 reactive 转换为 data 中的普通对象
      consentContent:
        "       感谢您考虑参与我们的调查问卷。这份问卷旨在收集关于XXX主题的重要信息，以帮助我们更好地理解这一领域。您的参与对于我们的研究至关重要。在您开始之前，我们希望您了解以下事项:      \n" +
        "      1.目的与保密性: 此调查的目的在于收集关于XXX主题的数据。您的个人信息(包括姓名和联系方式)将严格保密，只用于统计分析，并在报告中以匿名方式星现。     \n" +
        "      2.自愿参与: 您的参与是完全自愿的。如果您在任何时候决定退出调查，都可以自由地停止回答问题,数据保护: 我们将采取所有必要的安全措施来保护您的个人信息。数据将被存储在受密码保护的系统中，并且只有经过授权的人员可以访问。",
    };
  },
  watch: {
    show(newVal) {
      console.log("efwefewfwe4ee2r23r23r", newVal);

      this.viseable = newVal;
    },
  },
  methods: {
    open() {},
    close() {
      if (this.slotStatus) {
        this.$emit("close");
        console.log("props.slotStatus", this.slotStatus);
      }
      // this.$emit('close')
    },
    handleClick(e) {
      this.$emit("confirm", e);
    },
    // 新增：点击弹窗外部关闭
    handlePopupClose() {
      this.close();
    },
    handleCloseClick() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1009;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1009;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  //   width: 930px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 1009;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

// .popup-content {
//   background: #fff;
//   max-width: 90%;
//   max-height: 90vh;
//   overflow-y: auto;
//   position: relative;
// }

.popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  &:hover {
    color: #333;
  }
}

.bg-view {
  width: 321px; // 642rpx 转换为 px（1rpx=0.5px）
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.header-view {
  width: 100%;
  height: 59px; // 118rpx
  background-color: #ffffff;
  border-top-right-radius: 10px; // 20rpx
  border-top-left-radius: 10px;
  padding: 0 13.5px; // 27rpx
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
}

.body-view {
  width: 321px; // 642rpx
  max-height: 400px; // 800rpx
  padding: 0 15px; // 30rpx
  box-sizing: border-box;
  margin-top: 10px; // 20rpx
}

.message {
  width: 80%;
  text-align: center;
  color: #555555;
  font-size: 15px; // 30rpx
  font-weight: 400;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  word-break: break-all;
}

.devider_view {
  width: 100%;
  height: 43.5px; // 87rpx
  margin-top: 10px; // 20rpx
  border-radius: 4px; // 8rpx
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-views {
  width: 100%;
  padding: 0 15px; // 30rpx
  box-sizing: border-box;
  margin-top: 10px; // 20rpx
  margin-bottom: 15px; // 30rpx;

  &.active {
    gap: 10px; // 20rpx;

    .btn1 {
      width: 30%;
    }

    .btn2 {
      width: 70%;
    }
  }
}

.btn1 {
  width: 137.5px; // 275rpx
  height: 40px; // 80rpx
  line-height: 40px;
  text-align: center;
  border: 1px solid #3a60ff;
  font-size: 16px; // 32rpx
  font-weight: 600;
  color: #3a60ff;
  border-radius: 40px; // 80rpx
  cursor: pointer;
}

.btn2 {
  width: 137.5px; // 275rpx
  height: 40px; // 80rpx
  line-height: 40px;
  text-align: center;
  border: 1px solid #3a60ff;
  background: #3a60ff;
  font-size: 16px; // 32rpx
  font-weight: 600;
  color: #ffffff;
  border-radius: 40px; // 80rpx
  cursor: pointer;
}

.bg-other {
  width: 440px; // 690rpx
  padding: 0 10px; // 20rpx
  box-sizing: border-box;
}

.choose-btn {
  width: 200px; // 400rpx
  height: 40px; // 80rpx
  background-color: #3a60ff;
  color: #fff;
  font-size: 15px; // 30rpx
  font-weight: 600;
  border-radius: 20px; // 40rpx
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.content-box {
  width: 100%;
  padding: 15px 6px; // 30rpx 12rpx
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 4px; // 8rpx
  margin-top: 10px; // 20rpx

  .title {
    width: 100%;
    font-size: 19px; // 38rpx
    font-weight: 500;
    color: #323b5a;
    line-height: 1;
    text-align: center;
  }

  .desc {
    font-size: 14px; // 28rpx
    font-weight: 500;
    color: #2b2f36;
    line-height: 1;
    margin-top: 15px; // 30rpx
    margin-left: 6.5px; // 13rpx
  }

  .textarea-box {
    width: 100%;
    padding: 10px; // 20rpx
    box-sizing: border-box;
    border: 1px dashed #3a60ff;
    border-radius: 1px; // 2rpx
    margin-top: 10px; // 20rpx
    white-space: pre-wrap;
    font-size: 14px; // 28rpx
  }
}

.signature-desc {
  height: 21px; // 42rpx
  font-size: 15px; // 30rpx
  font-weight: 400;
  text-align: left;
  color: #767d98;
  line-height: 21px;
}

.signature-box {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 4px; // 8rpx
  padding: 25px 12px; // 50rpx 24rpx
  box-sizing: border-box;
  margin-top: 10px; // 20rpx
  font-size: 45px; // 90rpx
  font-weight: 600;
  color: #323b5a;
  line-height: 1;
  text-align: center;
}

.btn-box {
  display: flex;
  justify-content: space-between;
  margin-top: 10px; // 20rpx

  .cancel-btn {
    width: 149px; // 298rpx
    height: 41.5px; // 83rpx
    line-height: 41.5px;
    color: #3a60ff;
    background-color: #ffffff;
    border: 1px solid #3a60ff;
    font-size: 15px; // 30rpx
    font-weight: 600;
    border-radius: 5px; // 10rpx
    text-align: center;
    cursor: pointer;
  }

  .save-btn {
    width: 149px; // 298rpx
    height: 41.5px; // 83rpx
    line-height: 41.5px;
    color: #ffffff;
    background-color: #3a60ff;
    border: 1px solid #3a60ff;
    font-size: 15px; // 30rpx
    font-weight: 600;
    border-radius: 5px; // 10rpx
    text-align: center;
    cursor: pointer;
  }
}

.clear-text {
  font-size: 13px; // 26rpx
  font-weight: 400;
  color: #3a60ff;
  cursor: pointer;
}

.share-view {
  flex: 1;
  margin-left: 8px; // 16rpx
  border: 1px solid #dadada;
  border-radius: 4px; // 8rpx
  padding: 10px; // 20rpx
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/DemonstratePopup/DemonstratePopup.vue